import ChevronUp from '../src/ChevronUp/index.tsx';
export default ChevronUp;
